import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { encryptId } from "../../../Components/CryptoComponent";

function ProfessionList() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const columns = [
    { field: "PI_Id", label: "#" },
    { field: "PI_Name", label: "Profession" },
    { field: "PI_Status", label: "Status" },
  ];

  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.PI_Id));
        navigate(
          `/ProfessionLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Profession/list`}
      actions={actions}
      title={`Profession`}
      linkvalue={`/ProfessionLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default ProfessionList;
